/* All Offers section (sections/aniwell-offers.liquid): copy-code buttons, "open the spin wheel" buttons, and
   hiding offers whose dates are out of range. Liquid already leaves out offers outside their dates; this re-checks
   in the visitor's browser because Shopify can serve a cached page after an offer ends. */
(function () {
  function today() {
    var d = new Date();
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }

  function applyDates(root) {
    // Theme editor: keep every offer visible (Liquid marks the ones outside their dates) so it can be edited
    if (window.Shopify && window.Shopify.designMode) return;
    var now = today();
    Array.prototype.forEach.call(root.querySelectorAll('[data-of-start], [data-of-end]'), function (el) {
      var start = parseInt(el.getAttribute('data-of-start') || '0', 10);
      var end = parseInt(el.getAttribute('data-of-end') || '0', 10);
      el.hidden = (start && now < start) || (end && now > end);
    });
    // Hide a group (and its heading) once every offer in it is hidden
    Array.prototype.forEach.call(root.querySelectorAll('[data-of-group]'), function (group) {
      var items = group.querySelectorAll('[data-of-item]');
      var shown = Array.prototype.filter.call(items, function (el) { return !el.hidden; }).length;
      var heading = root.querySelector('[data-of-heading="' + group.getAttribute('data-of-group') + '"]');
      group.hidden = shown === 0;
      if (heading) heading.hidden = shown === 0;
      group.style.setProperty('--of-steps', String(Math.max(shown, 1)));
      group.style.setProperty('--of-more-cols', String(Math.min(Math.max(shown, 1), 3)));
      group.classList.toggle('is-single', shown === 1);
    });
  }

  function copyCode(btn) {
    var code = btn.getAttribute('data-of-copy');
    var label = btn.getAttribute('data-copied') || 'Copied';
    var original = btn.textContent;
    var done = function () {
      btn.textContent = label;
      btn.classList.add('is-copied');
      setTimeout(function () { btn.textContent = original; btn.classList.remove('is-copied'); }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var temp = document.createElement('textarea');
      temp.value = code;
      document.body.appendChild(temp);
      temp.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(temp);
      done();
    }
  }

  // The spin wheel (sections/spin-the-wheel.liquid) opens from its floating icon's button.
  function spinButton() {
    return document.querySelector('.spin-launcher__btn');
  }

  function init(root) {
    if (!root || root.getAttribute('data-of-ready')) return;
    root.setAttribute('data-of-ready', 'true');
    applyDates(root);
    // "Open the spin wheel" buttons only make sense when the wheel is on the page. Its script moves the
    // icon to <body> on DOMContentLoaded, so check once everything has loaded.
    var checkSpin = function () {
      Array.prototype.forEach.call(root.querySelectorAll('[data-of-spin]'), function (btn) {
        if (!spinButton()) btn.hidden = true;
      });
    };
    if (document.readyState === 'complete') checkSpin(); else window.addEventListener('load', checkSpin);
    root.addEventListener('click', function (e) {
      var copy = e.target.closest('[data-of-copy]');
      if (copy) { e.preventDefault(); copyCode(copy); return; }
      var spin = e.target.closest('[data-of-spin]');
      if (spin) {
        e.preventDefault();
        var opener = spinButton();
        if (opener) opener.click();
      }
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-aw-offers]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-aw-offers]')); });
})();
